module.exports = __webpack_public_path__ + "img/books.0cfc9055.svg";